var _gaq = _gaq || [];

window.web2Lead = function() {
    return {
        open: false,

        delayModal() {
            let self = this;
            const web2LeadCookie = document.cookie
                .split('; ')
                .find(row => row.startsWith('hideWeb2Lead='));

            if (web2LeadCookie) {
                return;
            }

            setTimeout(function() {
                self.open = true;
                _gaq.push(['_trackEvent', 'Newsletter Modal', 'shown']);
            }, 5000);
        },
        closeModal() {
            this.open = false;
            document.cookie = 'hideWeb2Lead=true;  path=/';
            if (!window.newsletterFormSubmitted) {
                _gaq.push(['_trackEvent', 'Newsletter Modal', 'user closed']);
            }
        },
    };
};
